
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { menuAction } from "ReduxReducers/menuReducer";
import brandDark from "assets/images/logo-ct-dark.png";
import brandWhite from "assets/images/logo-ct.png";
import theme from "assets/theme";
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";
import themeRTL from "assets/theme/theme-rtl";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import LoadingModal from "components/LoadingModel/loadingModal";
import DeleteModal from "components/deletemodal/deletemodal";
import { useMaterialUIController, } from "context";
import Configurator from "examples/Configurator";
import Sidenav from "examples/Sidenav";
import { useEffect, useMemo, useState } from "react";
import 'react-datepicker/dist/react-datepicker.css';
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import routes from "routes";
import { SocketProvider } from "socket/SocketContext";
import rtlPlugin from "stylis-plugin-rtl/dist/stylis-rtl";
import { appConstants } from "utils/appConstants";
import { getCityAndState } from "utils/generic";
import './../src/App.scss';
import { ToastContainer } from "react-toastify";
import AppModal from "components/appModel/appmodal";
let GET_USER_DETAILS;
export default function App() {
  const [controller] = useMaterialUIController();
  const reDispatch = useDispatch()
  const navigate = useNavigate()
  const {
    direction,
    layout,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;

  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  let logoName;
  const loading = useSelector((state) => state.loader.isLoading);
  const countryState = useSelector((state) => state.countryState);
  const menu = useSelector((state) => state.menu.menuState);

  GET_USER_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
  const isChildUser = GET_USER_DETAILS?.userKey;

  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);


  // // Open sidenav when mouse enter on mini sidenav
  // const handleOnMouseEnter = () => {
  //   if (miniSidenav && !onMouseEnter) {
  //     setMiniSidenav(dispatch, false);
  //     setOnMouseEnter(true);
  //   }
  // };

  // // Close sidenav when mouse leave mini sidenav
  // const handleOnMouseLeave = () => {
  //   if (onMouseEnter) {
  //     setMiniSidenav(dispatch, true);
  //     setOnMouseEnter(false);
  //   }
  // };
  useEffect(() => {
    if (window.location.pathname === "/customerLogin" || window.location.pathname === "/login") {
      sessionStorage.removeItem("SIGN_AP_DETAILS");
      sessionStorage.removeItem("LOGIN_DETAILS");
      sessionStorage.removeItem("ROLE_RIGHTS_LOGIN")
      sessionStorage.removeItem("ROLE")
    }

    if (!countryState.check) {
      getCityAndState()
    }

  }, [window.location.pathname])

  let userDetails = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
  let login = sessionStorage.getItem("ROLE_NAME")
  if (login === "Super Admin") {
    logoName = "Invoice & Recover"

  } else {
    if (userDetails !== "" && userDetails !== undefined && userDetails !== null) {
      logoName = `${userDetails.firstName}  ${userDetails.lastName} `
    } else {
      logoName = "Invoice & Recover"
    }
  }

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const { tableBorder } = getColorMappings(sidenavColor);

  var element = document.getElementsByTagName('fieldset');

  for (let i = 0; i < element.length; i++) {
    // let res = document.querySelector('.MuiOutlinedInput-notchedOutline');
    element[i].style.borderColor = darkMode ? "white" : tableBorder;
  }

  var checboxMain = document.querySelectorAll('.MuiCheckbox-root');
  for (let i = 0; i < checboxMain.length; i++) {
    var use = checboxMain[i].getElementsByTagName('svg');
    if (darkMode) {
      use[0].style.borderColor = 'white';
    } else {
      use[0].style.borderColor = 'black';
    }
  }
  var checkboxMain = document.querySelectorAll('.MuiRadio-root');
  for (let i = 0; i < checkboxMain.length; i++) {
    let use = checkboxMain[i].getElementsByTagName('svg');
    if (darkMode) {
      use[0].style.borderColor = 'white';
    } else {
      use[0].style.borderColor = 'black';
    }

  }
  var disabledval = document.querySelectorAll('.Mui-disabled');
  for (let i = 0; i < disabledval.length; i++) {
    var usevalue = disabledval[i].getElementsByTagName('input');


    if (usevalue.length > 0) {
      if (darkMode) {
        usevalue[0].style.setProperty("-webkit-text-fill-color", "white", "important");
      } else {
        usevalue[0].style.removeProperty("-webkit-text-fill-color");
      }
    }
  }

  // var dropicons = document.querySelectorAll('.MuiInputBase-root');
  // for (let i = 0; i < dropicons.length; i++) {
  //   var svgicon = dropicons[i].getElementsByTagName('svg');
  //   if (svgicon.length > 0) {
  //     if (darkMode) {
  //       svgicon[0].setAttribute("style", "fill: white !important;");
  //     } else {
  //       svgicon[0].setAttribute("style", "fill: ");
  //     }
  //   }
  // }
  var disabledvalues = document.querySelectorAll('.Mui-disabled');

  for (let i = 0; i < disabledvalues.length; i++) {
    if (darkMode) {
      disabledvalues[i].style.setProperty("-webkit-text-fill-color", "white", "important");
    } else {
      disabledvalues[i].style.removeProperty("-webkit-text-fill-color");
    }
  }

  var disablefields = document.querySelectorAll(".Mui-disabled");
  for (let i = 0; i < disablefields.length; i++) {
    var disabled = disablefields[i].getElementsByClassName('MuiInputBase-input');
    if (disabled.length > 0 && disabled[0]) {
      if (darkMode) {
        disabled[0].style.opacity = "0.7";
      }
    }
  }





  var dropicons = document.querySelectorAll('.MuiInputBase-root');
  for (let i = 0; i < dropicons.length; i++) {
    var svgicon = dropicons[i].getElementsByTagName('svg');
    if (svgicon.length > 0) {
      if (darkMode) {
        svgicon[0].setAttribute("style", "fill: white !important; opacity: 0.7; !important");
      } else {
        svgicon[0].setAttribute("style", "fill:");
      }
    }
  }

  let noRecord = document.getElementsByClassName("rdt_Table")[0];

  if (noRecord) {
    noRecord.getElementsByTagName("div")[0].style.fontSize = "15px";
  }

  let tabBorder = document.getElementsByClassName("tab-container");

  if (tabBorder) {
    for (let i = 0; i < tabBorder.length; i++) {
      tabBorder[i].style.borderColor = tableBorder;
    }
  }

  let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
  for (let i = 0; i < labelShrink.length; i++) {
    labelShrink[i].style.color = darkMode ? "white" : tableBorder;;
  }

  // var addNewButton = document.getElementsByClassName('btn-block');
  const getRoutesGuarded = (allRoutes, val) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutesGuarded(route.collapse);
      }
      if (val) {

        if (route.route) {
          return <Route exact path={route.route} element={route.component} key={route.key} title={route.title} />;
        }

      } else {
        if (route.guarded === val) {
          if (route.route) {
            return <Route exact path={route.route} element={route.component} key={route.key} title={route.title} />;
          }
        }
      }
      return null;
    });
  const handleRoute = async (id) => {
    reDispatch(menuAction(false))
    navigate("/subscriptions")
  };

  const handleCancel = (name) => (event) => {
    reDispatch(menuAction(false))
  };
  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
              brandName="Material Dashboard 2"
              routes={routes}
            // onMouseEnter={handleOnMouseEnter}
            // onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutesGuarded(routes, userDetails === null ? false : true)}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName={logoName}
            routes={routes}
          // onMouseEnter={handleOnMouseEnter}
          // onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
        </>
      )}
      {layout === "vr" && <Configurator />}
      <SocketProvider socketUrl={appConstants.socketUrl}>
        <Routes>
          {getRoutesGuarded(routes, userDetails === null ? false : true)}
          {<> <Route path="*" element={<Navigate to={sessionStorage.getItem("LOGIN_ROUTE") !== null ? sessionStorage.getItem("LOGIN_ROUTE") : 'Login'} />} /></>}
        </Routes>
      </SocketProvider>
      <LoadingModal loading={loading} />
      <ToastContainer />
      {!isChildUser && isChildUser !== 'ChildUser' ?
        <DeleteModal
          open={menu}
          handleDelete={handleRoute}
          message={
            <span style={{ textAlign: 'center', display: 'block' }}>
              "This Screen is not available in current plan. Please upgrade the plan to use this screen."
            </span>
          }
          handleCancel={handleCancel("handleCancel")}
          closeModalClick={handleCancel("closeModalClick")} />
        :

        <AppModal
          open={menu}
          message={
            <span style={{ textAlign: 'center', display: 'block' }}>
              "You are not authorized to access this screen. Please contact your administrator for assistance."
            </span>
          }
          handleCancel={handleCancel("handleCancel")}
          closeModalClick={handleCancel("closeModalClick")}

        />
      }

    </ThemeProvider>
  );
}
